module.exports = __webpack_public_path__ + "zilla-slab-latin-300italic.c3e55b6e5c02d56989e015b54ca85465.woff2";